// @ts-nocheck
import { USAGE_STATS_ERROR, USAGE_STATS_LOADING, USAGE_STATS_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const UsageStatsReducer = (state = initialState, action) => {
    switch (action.type) {
        case USAGE_STATS_LOADING:
            return Object.assign({}, state, { loading: true })
        case USAGE_STATS_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case USAGE_STATS_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

